<div>
    <app-header></app-header>
    <div class="container-fluid finzy-font-color">
        <div class="finzyfont">
            <app-investormenu></app-investormenu>
            <h3 class="text-center mb-4">
                Here are {{ noOfLoansToBeFetched }} loans funded on finzy in the last few days
            </h3>
            <div class="col-md-9 col-md-offset-1">
                <div class="row">
                    <div class="row">
                        
                        <div class="center-align pl-4 pr-4">
                            <div class="text-center content ng-tns-c380-4 transparent-border grey-section w-100 mt-1">
                                <p class="m-0 p-4">Listed below are real finzy loans that investors have invested
                                    into.<br />
                                    For a better understanding of different loan rating categories, view our detailed
                                    document on finzy ratings and sample borrower profiles
                                    <a target="_blank"
                                        [href]="getSampleFileUrl()" (click)="openFromMobile($event,true)">here</a>.
                                </p>
                            </div>
                        </div>
                    </div>
                    <div>
                        <div class="center-align margin-top-20 margin-bottom-20"
                            *ngIf="dataSource.data.length === 0 && networkCallInProgress">
                            <mat-spinner [diameter]="35"></mat-spinner>
                        </div>
                        <div *ngIf="dataSource.data.length > 0"
                            class="table-container {{isMobile?'':'responsive-table'}}">
                            <mat-table [dataSource]="dataSource" matSort class="finzyfont margin-top-20"
                                multiTemplateDataRows>
                                <ng-container matColumnDef="rating">
                                    <mat-header-cell *matHeaderCellDef class="col-100" mat-sort-header>Finzy Rating
                                    </mat-header-cell>
                                    <mat-cell *matCellDef="let element" class="col-100">
                                        <span class="small-text">{{element.rating}}</span>
                                    </mat-cell>
                                </ng-container>
                                <ng-container matColumnDef="roi">
                                    <mat-header-cell *matHeaderCellDef class="col-150">Interest Rate</mat-header-cell>
                                    <mat-cell *matCellDef="let element" class="col-150">
                                        <span class="small-text">{{element.roi}}%</span>
                                    </mat-cell>
                                </ng-container>
                                <ng-container matColumnDef="loanAmount">
                                    <mat-header-cell *matHeaderCellDef class="col-200">Loan Amount</mat-header-cell>
                                    <mat-cell *matCellDef="let element" class="col-200">
                                        <app-indian-currency-formatter [amount]="element.loan_amount">
                                        </app-indian-currency-formatter>
                                    </mat-cell>
                                </ng-container>
                                <ng-container matColumnDef="loanPurpose">
                                    <mat-header-cell *matHeaderCellDef class="col-200">Loan Purpose</mat-header-cell>
                                    <mat-cell *matCellDef="let element" class="col-200">
                                        <span class="small-text">{{element.loan_reason}}</span>
                                    </mat-cell>
                                </ng-container>
                                <ng-container matColumnDef="location">
                                    <mat-header-cell *matHeaderCellDef class="col-230">City</mat-header-cell>
                                    <mat-cell *matCellDef="let element" class="col-230">
                                        <span class="small-text">{{element.location}}</span>
                                    </mat-cell>
                                </ng-container>
                                <ng-container matColumnDef="timeTakenInLoanFunding">
                                    <mat-header-cell *matHeaderCellDef class="col-200">Time taken to fully fund the loan
                                    </mat-header-cell>
                                    <mat-cell *matCellDef="let element" class="col-200">
                                        <span class="small-text">{{element.timeTakenInLoanFunding}}</span>
                                    </mat-cell>
                                </ng-container>
                                <ng-container matColumnDef="noOfInvestors">
                                    <mat-header-cell *matHeaderCellDef class="col-150">No of Investors</mat-header-cell>
                                    <mat-cell *matCellDef="let element" class="col-150">
                                        <span class="small-text">{{element.noOfInvestors}}</span>
                                    </mat-cell>
                                </ng-container>
                                <ng-container matColumnDef="borrowerDetails">
                                    <mat-header-cell *matHeaderCellDef class="col-200">Borrower</mat-header-cell>
                                    <mat-cell *matCellDef="let element" class="col-200">
                                        <a (click)="viewBorrowerDetails(element)"
                                            class="small-text cursor-pointer">Borrower Details</a>
                                    </mat-cell>
                                </ng-container>
                                <ng-container matColumnDef="accordion_arrow">
                                    <mat-header-cell *matHeaderCellDef> </mat-header-cell>
                                    <mat-cell *matCellDef="let element" style="justify-content: flex-end;max-width: 46px;">
                                        <mat-icon style="font-family: 'Material Icons';font-size: 18px;">{{element == expandedElement ?
                                            'arrow_drop_up' : 'arrow_drop_down'}}
                                        </mat-icon>
                                    </mat-cell>
                                </ng-container>
                                <ng-container matColumnDef="expandedDetail">
                                    <mat-cell *matCellDef="let element">
                                        <div class="accordion-element-detail" *ngIf="isMobile"
                                            [@detailExpand]="element == expandedElement ? 'expanded' : 'collapsed'">
                                            <div
                                                style="display: flex; width:calc(100% - 16px);border-bottom: 1px solid #efefef;;line-height: 1;">
                                                <div style="padding: 8px;width: 50%;">
                                                    City
                                                </div>
                                                <div style="padding: 8px;width: 50%;">
                                                    <span>{{element.location}}</span>
                                                </div>
                                            </div>
                                            <div
                                                style="display: flex; width:calc(100% - 16px);border-bottom: 1px solid #efefef;;line-height: 1;">
                                                <div style="padding: 8px;width: 50%">
                                                    Time taken to fully fund the loan
                                                </div>
                                                <div style="padding: 8px;width: 50%;">
                                                    <span>{{element.timeTakenInLoanFunding}}</span>
                                                </div>
                                            </div>
                                            <div
                                                style="display: flex; width:calc(100% - 16px);border-bottom: 1px solid #efefef;line-height: 1;">
                                                <div style="padding: 8px;width: 50%;">
                                                    No of Investors
                                                </div>
                                                <div style="padding: 8px;width: 50%;">
                                                    <span>{{element.noOfInvestors}}</span>
                                                </div>
                                            </div>
                                            <div
                                                style="display: flex; width:calc(100% - 16px);border-bottom: 1px solid #efefef;line-height: 1;">
                                                <div style="padding: 8px;width: 50%;">
                                                    Borrower
                                                </div>
                                                <div style="padding: 8px;width: 50%;">
                                                    <span (click)="viewBorrowerDetails(element)" style="color:#0d3abc" class="small-text cursor-pointer">Borrower Details</span>
                                                </div>
                                            </div>
                                        </div>
                                    </mat-cell>
                                </ng-container>
                                <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
                                <mat-row *matRowDef="let element; columns: displayedColumns;"
                                    class="accordion-element-row"
                                    [class.accordion-expanded-row]="expandedElement === element"
                                    (click)="expandedElement = expandedElement === element ? null : element"></mat-row>
                                <mat-row *matRowDef="let row; columns: ['expandedDetail']" class="accordion-detail-row">
                                </mat-row>

                            </mat-table>
                            <mat-paginator [length]="getPageLengthInPagination(noOfLoansToBeFetched/4)"
                                [pageSize]="getPageLengthInPagination(noOfLoansToBeFetched/4)" [pageSizeOptions]="[getPageLengthInPagination(noOfLoansToBeFetched/4),
                                           getPageLengthInPagination(noOfLoansToBeFetched/2), noOfLoansToBeFetched]">
                            </mat-paginator>
                            <div class=" margin-bottom-20"></div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <app-footer></app-footer>
</div>